import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { Lock, LifeBuoy } from "lucide-react";
import { api } from "../lib/api";

export function useAccess() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/access/me").then((r) => setA(r.data)).catch(() => setA(null)); }, []);
  return a;
}

export const canLearn = (a, courseId) => !a || a.learning_all || (courseId ? a.courses.includes(courseId) : a.courses.length > 0);

export const isAccessError = (e) => e?.response?.status === 403 && e?.response?.data?.detail?.code === "access_required";

export function AccessRequired({ area, testid = "access-required" }) {
  const { t } = useTranslation();
  const loc = useLocation();
  return (
    <div data-testid={testid} role="status" className="flex flex-wrap items-start gap-3 rounded-2xl border border-amber-line bg-amber-soft p-4 text-sm text-amber-ink">
      <Lock className="mt-0.5 h-5 w-5 shrink-0" aria-hidden />
      <div className="min-w-0 flex-1 basis-[14rem]">
        <p className="font-bold">{t("acc.required")}</p>
        <p>{t(`acc.required_${area}`)}</p>
      </div>
      <Link to={`/pricing?return=${encodeURIComponent(loc.pathname)}`} data-testid={`${testid}-pricing-link`} className="inline-flex min-h-[44px] items-center gap-1.5 rounded-xl bg-primary px-4 font-semibold text-primary-foreground">{t("b4.see_packages")}</Link>
      <Link to="/help#access" data-testid={`${testid}-support-link`} className="inline-flex min-h-[44px] items-center gap-1.5 rounded-xl border border-current bg-white px-4 font-semibold underline-offset-2 hover:underline">
        <LifeBuoy className="h-4 w-4" aria-hidden />{t("acc.contact_support")}
      </Link>
    </div>
  );
}

export function SupportEmail() {
  const { t } = useTranslation();
  const [s, setS] = useState(undefined);
  useEffect(() => { api.get("/settings/public").then((r) => setS(r.data.support_email)).catch(() => setS(null)); }, []);
  if (s === undefined) return null;
  return s ? <a href={`mailto:${s}`} data-testid="support-email" className="font-semibold underline">{s}</a>
    : <span data-testid="support-email" className="font-semibold">{t("help.email_tbc")}</span>;
}
